export enum PeriodSubscription {
    oneMonth = 'switcher.one.month',
    oneYear = 'switcher.one.year'
}
